export enum MessageType {
  Saved,
  ServerError,
  AwaitingResponse,
  NotFound,
  StillLoading,
  UpdateRecordNotFound,
  UnknownError,
  Offline,
}
